//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'
import Button from '@/components/Shared/Button.vue'

export default {
  components: { ModalWithTitleBar, Button },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collaboratorImage: '/img/projects/collaborator.svg',
      supervisorImage: '/img/projects/supervisor.svg',
    }
  },
  methods: {
    onToggle() {
      this.$emit('toggle')
    },
    openAddSupervisorModal() {
      this.$emit('addSupervisor')
    },
    openAddCollaboratorModal() {
      this.$emit('addCollaborator')
    },
  },
}
